'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wallet = function Wallet(_ref) {
  var name = _ref.name,
      type = _ref.type,
      description = _ref.description,
      _onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'wallet ' + type },
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'strong',
        null,
        name
      ),
      _react2.default.createElement(
        'span',
        null,
        description
      )
    ),
    _react2.default.createElement(
      'button',
      { name: 'select', className: 'btn', type: 'button', value: type, onClick: function onClick() {
          return _onClick(type);
        } },
      'Choose'
    )
  );
};

Wallet.defaultProps = {
  onClick: function onClick() {
    return null;
  }
};

Wallet.propTypes = {
  name: _propTypes2.default.string.isRequired,
  type: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.node.isRequired,
  onClick: _propTypes2.default.func
};

exports.default = Wallet;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/wallet/Wallet.js
// module id = 1141
// module chunks = 0